import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

import { EscolaridadService } from '../../services/escolaridad/escolaridad.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { NacimientoService } from 'src/app/services/nacimiento/nacimiento.service';
import { PrestamosService } from 'src/app/services/prestamos/prestamos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { AfiliacionService } from '../../services/afiliacion/afiliacion.service';
import { Usuario } from '../../models/usuario/usuario.model';
import { Hijo } from '../../models/hijo/hijo.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { AppComponent } from 'src/app/app.component';
import { TextosService } from '../../services/textos/textos.service';
import Swal from 'sweetalert2';


declare const Rut: any;
declare const ageCalculator: any;

@Component({
  selector: 'app-nacimiento-jub',
  templateUrl: '../../pages/nacimiento/nacimiento.component.html',
  styleUrls: ['../../pages/nacimiento/nacimiento.component.css']
})

export class NacimientoJubComponent implements OnInit {

  rol: string = localStorage.getItem("rol")
  nombreUsuario: string = localStorage.getItem("nombreUsuario")
  estado: any
  idEjecutivo = localStorage.getItem("idUsuario")
  rutUsuario: any
  totalMaximo: any
  diasDiferencia: any
  diasFechaAdopcion: any  
  tipoNac: any
  tipos: any
  textos: any
  linkTexto: any
  postulantes: any[];
  cantidadArchivos: any = 1
  afiliado: any = { rutAfiliado: '', idAfiliado: '', nombreAfiliado: '', apellidoAfiliado: '' };
  hijo: any = { nombres: '', run: '', fechaNacimiento: '' };

  buscador: any =
    {
      rut: '', rut2: '', rutHijo: '', rutAfiliado: '', idRegion: '', fechaInicio: '', fechaFin: '', itemsPerPage: 5, currentPage: 1, idSolicitud: '',
      estado: ['INGRESADA', 'EN VALIDACION', 'RECHAZADA', 'APROBADA']
    }
  nacimiento: any = {
    rutAfiliado: '', rutHijo: '', nombres: '', fechaNacimiento: '', fechaAdopcion: '',
    tipoNacimiento: '0',
    archivo: [], archivoTest: null, archivoTest2: null, archivoTest3: null, archivoTest4: null, archivoTest5: null, archivoTest6: null
  }

  constructor(private router: Router, public nacimientoService: NacimientoService, private escolaridadService: EscolaridadService,
    public prestamosService: PrestamosService, private productosService: ProductosService, private dialog: MatDialog,
    private postulacionesService: PostulacionesService,private afiliacionService: AfiliacionService, private appComponent: AppComponent,
    private textosService: TextosService) {

  }

  ngOnInit(): void { this.loadData() }
  loadData() {
    let vm = this
    this.nacimiento.nomNacDeshabilitado = false
    this.nacimiento.fechaNacDeshabilitado = false
    this.nacimiento.fechaAdopcionDeshabilitado = false
    if(localStorage.getItem("jubilado")!='true' && !localStorage.getItem("rol"))
    {
        this.appComponent.logoutJubilado();
    }
    
    if (this.rol == 'ROLE_AFILIADO' || this.rol == 'ROLE_JUBILADO') {
      this.afiliado.nombreAfiliado = this.nombreUsuario;
      this.afiliado.rutAfiliado = this.rutUsuario;
      this.afiliado.idAfiliado = this.idEjecutivo;
    }

    this.nacimientoService.traeTipoNacimiento().then(
      tipo => this.tipos = tipo
    ).catch(error => console.log(error))

    this.productosService.obtieneProductos().then
    (
        productos => productos[7].parametros.map( parametro => {
      
            if(parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_NACIMIENTO') {
                vm.diasDiferencia = parametro.valor
          
            }

            if(parametro.descripcion == 'DIAS_MAXIMOS_FECHA_ADOPCION') {
              vm.diasFechaAdopcion = parametro.valor
              
          }
        })
    )
    .catch ( error => console.log(error) )
    
    this.textosService.obtieneTextos()
    .then(textos => {
      vm.textos = textos; // Asigna el resultado del servicio a `this.textos`
      vm.linkTexto = vm.textos.find(item => item.tipoProducto === "NACIMIENTO")?.valor;             
    })
    .catch(error => {
      console.error('Error al obtener los textos:', error);
    });
    
  }


  buscaHijoRegistroCivil(rutABuscar: any, ubicacion: any) {
    if (Rut(rutABuscar)) {
      let rut = rutABuscar.split('.').join('').split('-')[0]

      this.traePostulantes(rut, ubicacion)
    }
    else { this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger') }
  }

  traePostulantes(rut: any, ubicacion: any) {
    if(this.rol != 'ROLE_AFILIADO' && this.rol != 'ROLE_JUBILADO'){  
      this.validarEstado(rut.split('-')[0] )
    }
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let vm = this
   
    this.prestamosService.traePostulantes(rut).then
      (
        (usuario: Usuario) => {

          if (ubicacion == 3) {
            vm.afiliado.nombreAfiliado = usuario.nombres + ' ' + usuario.apellidoPaterno
            vm.afiliado.rutAfiliado = usuario.rut + "-" + usuario.dv
            vm.afiliado.idAfiliado = usuario.id      
          }
          Swal.close();
        }

      ).catch(error => {
        console.log(error)
        if((error.error.message) && (error.error.message="Token expirado")){
          vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
          this.appComponent.logoutJubilado();
        }else{
          vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-danger')
        }
        Swal.close();
      })
  }

  validarEstado(rutAfiliado){
    this.afiliacionService.traeSoloAfiliadoSinEstados(rutAfiliado).then
    ( 
        (response: any) => {
            if(response.estadoAfiliado  && (response.estadoAfiliado.toUpperCase() =='PENDIENTE_AFILIACION'
                || response.estadoAfiliado.toUpperCase() =='DESAFILIADO'
                    || response.estadoAfiliado.toUpperCase() =='RECHAZAR_AFILIACION')){
                        console.log(response.estadoAfiliado)
                this.openAlertDialog('El afiliado se encuentra cerrado o en estado pendiente para solicitar beneficios.', 'btn-danger')
                this.router.navigate(['/index'])                 
            }
        }
    )
    .catch
    (
        error => {
          if((error.error.message) && (error.error.message="Token expirado")){
            this.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
            this.appComponent.logoutJubilado();
          }
        console.log('error :',error);
        }
    ) 
}

  buscarHijo(rutABuscar) {
    let rut = rutABuscar.split('-')[0] + rutABuscar.split('-')[1]
    console.log(rut)
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let vm = this
    if (Rut(rutABuscar)) {       
       
        this.nacimientoService.buscarHijo(rut).then
          (
            (hijo: Hijo) => {
             
              vm.nacimiento.nombres = hijo.nombres
              vm.nacimiento.run = hijo.run
              vm.nacimiento.fechaNacimiento = hijo.fechaNacimiento         
            
              this.nacimiento.nomNacDeshabilitado = true
              this.nacimiento.fechaNacDeshabilitado = true
            
              Swal.close();
            }

          ).catch(error => {
            console.log(error.status)
            if((error.error.message) && (error.error.message="Token expirado")){
              vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
              this.appComponent.logoutJubilado();
            }
            if(error.status == 500){
              Swal.close();
              vm.openAlertDialog('No se han encontrado beneficiarios con el RUT ingresado en el registro civil. Intente nuevamente.', 'btn-danger')
            }else{
              Swal.close();
              vm.openAlertDialog('No se ha logrado conectar con el servidor del registro civil.', 'btn-danger')
            }
            vm.nacimiento.nombres = ''
            vm.nacimiento.run = ''
            vm.nacimiento.fechaNacimiento = ''
            this.nacimiento.nomNacDeshabilitado = false
            this.nacimiento.fechaNacDeshabilitado = false
          })
    }else{
      Swal.close();
      this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger')
      vm.nacimiento.nombres = ''
      vm.nacimiento.run = ''
      vm.nacimiento.fechaNacimiento = ''
      this.nacimiento.deshabilitado = false
    }
  }

  inhabilitarPorTipo() {
    let vm = this
   
    vm.tipoNac = 0
    for (let i = 0; i < this.tipos.length; i++) {
      if (this.tipos[i].descripcion == 'NACIMIENTO' && this.tipos[i].id== vm.nacimiento.tipoNacimiento) {
        vm.tipoNac = this.tipos[i].id;
      } 
    }
    
    if(vm.tipoNac>0){
      this.nacimiento.fechaAdopcion=''
      this.nacimiento.fechaAdopcionDeshabilitado = true
    }else{
      this.nacimiento.fechaAdopcion=''
      this.nacimiento.fechaAdopcionDeshabilitado = false
    }
    
  }

  /*
  seleccionaArchivo(event: any)
  {
      if(event.target.files.length > 0)
      {
          console.log(event.target.files[0].type)
          this.nacimiento.archivo.tipo = event.target.files[0].type

          let vm = this
          let reader = new FileReader()

          reader.readAsDataURL(event.target.files[0])

          reader.onload = function() {
              vm.nacimiento.archivo.bytes = reader.result

              console.log(vm.nacimiento.archivo.bytes)
          }
      }
  }
  */

  seleccionaArchivo(event: any, numero: number) {
    if (event.target.files.length > 0) {
      console.log(event.target.files[0].type)

      let vm = this
      let reader = new FileReader()
      this.nacimiento.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
      reader.readAsDataURL(event.target.files[0])

      reader.onload = function () {
        vm.nacimiento.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }


      }
    }
  }

  sumaArchivo() {
    if (this.cantidadArchivos <= 5) {

      this.cantidadArchivos = this.cantidadArchivos + 1
    }
  }

  solicitar(form: NgForm) {
    var vm = this
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
   
    if (!vm.nacimiento.archivo[0]){
      Swal.close();
      this.openAlertDialog('es obligatorio adjuntar un archivo', 'btn-dark')
      return false
    }

    if (vm.nacimiento.archivo[0].extension != "application/pdf" && vm.nacimiento.archivo[0].extension != "image/jpeg" &&
     vm.nacimiento.archivo[0].extension != "image/png" && vm.nacimiento.archivo[0].extension != "image/jpg") {
      Swal.close();
      this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
      return false
    }
    
    let tipoIngreso='NACIMIENTO'
    Swal.showLoading();
    let usuarioId: any
    let fechaIngresadaNac = new Date(this.nacimiento.fechaNacimiento + 'T00:00')
    let fechamaxima = new Date()
   
    for (let i = 0; i < this.tipos.length; i++) {
      if(this.nacimiento.tipoNacimiento==this.tipos[i].id)
      tipoIngreso=this.tipos[i].descripcion;
    }
    
    if (fechaIngresadaNac > fechamaxima && tipoIngreso=='NACIMIENTO') {
      Swal.close();
      this.openAlertDialog('La fecha de Nacimiento no debe super la fecha actual. Favor revisar.', 'btn-dark')
      return false
    }
  
    let fechaNacIngresada = new Date(this.nacimiento.fechaNacimiento + 'T00:00')
    let fechaMinima = new Date()  
    fechaMinima.setDate(fechaMinima.getDate() - this.diasDiferencia)    

    if((fechaNacIngresada < fechaMinima || fechaNacIngresada > new Date()) && tipoIngreso=='NACIMIENTO')
    {
        this.openAlertDialog('La Fecha de solicitud supera la vigencia de 180 dias o excede la fecha actual. Favor revisar.', 'btn-dark')
        Swal.close();
        return false
    }

  
      let fechaAdopIngresada = new Date(this.nacimiento.fechaNacimiento + 'T00:00')
      let fechaMinimaAdopcion = new Date()  
      fechaMinimaAdopcion.setDate(fechaMinimaAdopcion.getDate() - this.diasFechaAdopcion)
     

    if((fechaAdopIngresada < fechaMinimaAdopcion ) && tipoIngreso!='NACIMIENTO')
    {
        this.openAlertDialog('La Fecha de adopción no debe superar los 5 años de edad. Favor revisar.', 'btn-dark')
        Swal.close();
        return false
    }
    
    if (this.nacimiento.fechaAdopcion == '' && tipoIngreso!='NACIMIENTO') {
      Swal.close();
      this.openAlertDialog('Se debe ingresar la fecha de adopción o Tuición. Favor revisar.', 'btn-dark')
      return false
    }
  

    usuarioId = this.afiliado.idAfiliado;
    let fechaAdopcion = null;
    if (!this.nacimiento.archivo) {
      Swal.close();
      this.openAlertDialog('Debe cargar el certificado como archivo', 'btn-dark')

      return false
    }
    if (!form.valid) {
      Swal.close();
      this.openAlertDialog('Debe ingresar todos los campos obligatorios', 'btn-dark')

      return false
    }

   
    let fechaNacimiento = this.nacimiento.fechaNacimiento.split('-')[2] + '-' +
      this.nacimiento.fechaNacimiento.split('-')[1] + '-' +
      this.nacimiento.fechaNacimiento.split('-')[0]
     
    if (this.nacimiento.fechaAdopcion) {
       fechaAdopcion = this.nacimiento.fechaAdopcion.split('-')[2] + '-' +
        this.nacimiento.fechaAdopcion.split('-')[1] + '-' +
        this.nacimiento.fechaAdopcion.split('-')[0]
    }
   
    this.nacimientoService.ingresarNacimiento(this.nacimiento, fechaNacimiento, fechaAdopcion, usuarioId, vm.idEjecutivo).then
      (
        response => {
          console.log(response)
          Swal.close();
          vm.openAlertDialog('Se ha ingresado la solicitud correctamente.', 'btn-success')
          vm.nacimiento.archivo.bytes = null, vm.nacimiento.archivo.tipo = null
          this.limpiarFormulario(); 
          form.reset()
          return
        }
      )
      .catch
      (error =>
        {
      
          if((error.error.message) && (error.error.message="Token expirado")){
            vm.openAlertDialog('Su sesión ha finalizado, por favor intente loguearse nuevamente.', 'btn-danger')
            this.appComponent.logoutJubilado();
          }
          if(error.status == 402){
            vm.openAlertDialog('Documento emitido en periodo de carencia.', 'btn-danger')
            Swal.close();
          } else if(error.status == 412){
            vm.openAlertDialog('Beneficio con fecha de evento anterior a la fecha de afiliación.', 'btn-danger')
            Swal.close();
          } else if(error.status == 406){
            vm.openAlertDialog('El rut del hijo ya se encuentra asociado al afiliado.', 'btn-danger')
            Swal.close();
          } else {
            vm.openAlertDialog('El sistema no ha podido generar su solicitud.', 'btn-danger')
            Swal.close();
          }

        }
      )
  }

  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }

  salir() {
    const dialogRef = this.dialog.open(ConfirmationDialog, {
      data: { message: '¿Esta seguro de salir del formulario?', buttonText: { ok: 'Si', cancel: 'No' } }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) { this.router.navigate(['/index']); }
    });
  }

  limpiarFormulario(){
    var vm = this
    vm.nacimiento.nombres = ''
    vm.nacimiento.rutHijo = ''
    vm.nacimiento.tipoNacimiento = 0    
    vm.nacimiento.fechaNacimiento = ''
    vm.nacimiento.fechaAdopcion = ''    
    vm.nacimiento.archivo=''
    vm.afiliado.nombreAfiliado = ''
    vm.afiliado.rutAfiliado = ''
    vm.afiliado.idAfiliado = ''
    vm.buscador.rutAfiliado = '' 
  }
         

}
